import React, { useState, useEffect } from "react";
import { buildWhatsAppLink } from "../constants";

export default function WhatsAppFloat() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 320);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href={buildWhatsAppLink("Hola Vallitas, quiero personalizar mi prenda.")}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      aria-label="Hablar por WhatsApp"
      className={`fixed bottom-6 right-6 z-50 inline-flex items-center gap-3 rounded-full bg-[#25D366] text-white px-4 py-4 sm:pl-5 sm:pr-6 shadow-[0_18px_40px_rgba(37,211,102,0.4)] hover:scale-[1.04] transition-all ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6 pointer-events-none"
      }`}
    >
      <span className="relative flex">
        <span className="absolute inset-0 rounded-full bg-white/40 animate-ping" />
        <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" className="relative">
          <path d="M20.52 3.48A11.93 11.93 0 0 0 12.05 0C5.5 0 .15 5.34.15 11.9c0 2.1.55 4.14 1.6 5.95L0 24l6.32-1.66a11.86 11.86 0 0 0 5.73 1.46h.01c6.55 0 11.9-5.34 11.9-11.9 0-3.18-1.24-6.17-3.44-8.42ZM12.06 21.5h-.01a9.6 9.6 0 0 1-4.9-1.34l-.35-.21-3.75.98 1-3.65-.23-.37a9.57 9.57 0 0 1-1.47-5.11c0-5.31 4.32-9.63 9.63-9.63a9.55 9.55 0 0 1 6.81 2.83 9.55 9.55 0 0 1 2.82 6.8c0 5.32-4.32 9.7-9.55 9.7Zm5.27-7.18c-.29-.14-1.7-.84-1.97-.94-.26-.1-.45-.14-.64.14-.19.28-.74.94-.91 1.13-.17.19-.34.21-.62.07-.29-.14-1.21-.45-2.3-1.42-.85-.76-1.42-1.7-1.59-1.98-.17-.29-.02-.44.13-.58.13-.13.29-.34.43-.51.14-.17.19-.29.29-.48.1-.19.05-.36-.02-.5-.07-.14-.64-1.55-.88-2.12-.23-.55-.46-.48-.64-.49l-.55-.01c-.19 0-.5.07-.76.36-.26.29-1 1-1 2.43 0 1.43 1.03 2.81 1.17 3 .14.19 2.02 3.08 4.9 4.32.69.3 1.22.48 1.64.61.69.22 1.31.19 1.81.12.55-.08 1.7-.7 1.94-1.37.24-.67.24-1.24.17-1.37-.07-.13-.26-.21-.55-.34Z" />
        </svg>
      </span>
      <span className="hidden sm:inline text-sm font-medium">Chatear ahora</span>
    </a>
  );
}
